import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Vali tootele juurde:

  <span style="color:#85c1dc;">**FI:**</span>
  Valitse tuotteeseen lisäksi:

  <span style="color:#85c1dc;">**RU:**</span>
  Выберите к товару:
*/
/* @__NO_SIDE_EFFECTS__ */
const m1625 = msg(
  mf`Vali tootele juurde:`,
  mf`Valitse tuotteeseen lisäksi:`,
  mf`Выберите к товару:`,
)

export { m1625 as 'w.module.product_description.product_hall' }